import ApiService from './ApiService';

export default {

    getInviteById(id) {
        return ApiService.get(`invites/${id}`);
    },

    sendInvites(data) {
        return ApiService.post('send-invites', data);
    },
    resendInvites(data){
        return ApiService.post('resend-invite', data);
    },

    assignInviteRole(data){
        return ApiService.post('invite-assign-role', data);
    },

    deleteInvite(id, deletePurchased = true) {
        return ApiService.delete(`delete-invite?invite_id=${id}&delete_purchased=${deletePurchased}`);
    },

    addInviteToDepartment(data) {
        return ApiService.post('add-invite-in-department', data);
    },

    deleteInviteFromDepartment(data) {
        return ApiService.post('delete-invite-from-department', data);
    }
}